import React from "react";
import { FaInstagram, FaWhatsapp, FaEnvelope } from "react-icons/fa";

const XFooter = () => {
  return (
    <footer className="bg-black text-gray-300 py-10 w-full overflow-hidden">
      <div className="container mx-auto px-4 text-center space-y-6">
        
        {/* Website Name */}
        <h2 className="text-2xl font-bold text-white">EMMEF TEX</h2>

        {/* Navigation Links */}
        <nav className="flex flex-wrap justify-center gap-4 font-medium">
          <a href="/" className="hover:text-green-400">Home</a>
          <a href="/collection" className="hover:text-green-400">Collection</a>
          <a href="/catalogue" className="hover:text-green-400">Catalogue</a>
          
          <a href="/contact" className="hover:text-green-400">Contact</a>
        </nav>

        {/* Social Icons */}
        <div className="flex justify-center space-x-6 text-2xl">
          <a href="https://www.instagram.com/emmeftex/" target="_blank" rel="noreferrer" className="hover:text-pink-500">
            <FaInstagram />
          </a>
          <a href="https://wa.me/919443036313" target="_blank" rel="noreferrer" className="hover:text-green-500">
            <FaWhatsapp />
          </a>
          <a href="mailto:emmeftex@gmail.com" className="hover:text-blue-400">
            <FaEnvelope />
          </a>
        </div>

        {/* Copyright */}
        <p className="text-sm text-gray-500">
          &copy; {new Date().getFullYear()} EMMEF TEX All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default XFooter;
